<ng-select [items]="dayTypes" bindLabel="name" bindValue="id" [(ngModel)]="gridItem.setup.period[model+'DateType']"
    placeholder="{{ 'Select'| i18next }}" [class.active]="dayTypesSelectOpened" (change)="SelectDayTypesChange($event)"
    (focus)="dayTypesSelectOpened=true" (blur)="dayTypesSelectOpened=false" [searchable]="false" [disabled]="disabled">
    <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index" dropdownPosition="bottom">
        {{ 'dashboard:' + item.name | i18next }}
    </ng-template>
    <ng-template ng-label-tmp let-item="item">
        {{ 'dashboard:' + item.name | i18next }}
    </ng-template>
</ng-select>
<ng-select [items]="valuesList" bindLabel="name" bindValue="id" [(ngModel)]="gridItem.setup.period[model+'Value']"
    placeholder="{{ 'Select'| i18next }}" [class.active]="weekDaysSelectOpened" (change)="SelectValueChange($event)"
    (focus)="weekDaysSelectOpened=true" (blur)="weekDaysSelectOpened=false" [searchable]="false"
    [disabled]="disabled || disableValueSelect">
    <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index" dropdownPosition="bottom">
        <ng-container *ngIf="[4,5,6].indexOf(gridItem.setup.period[this.model + 'DateType'])>-1">
            {{item.name}}
        </ng-container>
        <ng-container *ngIf="[4,5,6].indexOf(gridItem.setup.period[this.model + 'DateType'])<0">
            {{ 'dashboard:' + item.name | i18next }}
        </ng-container>
    </ng-template>
    <ng-template ng-label-tmp let-item="item">
        <ng-container *ngIf="[4,5,6].indexOf(gridItem.setup.period[this.model + 'DateType'])>-1">
            {{item.name}}
        </ng-container>
        <ng-container *ngIf="[4,5,6].indexOf(gridItem.setup.period[this.model + 'DateType'])<0">
            {{ 'dashboard:' + item.name | i18next }}
        </ng-container>
    </ng-template>
</ng-select>
<app-range-time-picker [(time)]="gridItem.setup.period[model+'Time']"
    [type]="model" [disabled]="disabled" (timeChange)="SelectValueChange($event)"></app-range-time-picker>
<!-- <app-time-picker [(time)]="gridItem.setup.period[model+'Time']" (timeChange)="SelectValueChange($event)"
    [disabled]="disabled"></app-time-picker> -->
